import { render, staticRenderFns } from "./SingleUserPicker.vue?vue&type=template&id=25528595"
import script from "./SingleUserPicker.vue?vue&type=script&lang=js"
export * from "./SingleUserPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25528595')) {
      api.createRecord('25528595', component.options)
    } else {
      api.reload('25528595', component.options)
    }
    module.hot.accept("./SingleUserPicker.vue?vue&type=template&id=25528595", function () {
      api.rerender('25528595', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/taskdetails/SingleUserPicker.vue"
export default component.exports